/* Click & Win display placements. Refresh remains entirely wrapper-owned. */
(() => {
  const root = document.querySelector('[data-caw-ads]');
  const flow = document.querySelector('click-and-win-flow');
  if (!root || !flow || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const rail = root.querySelector('[data-caw-rail]');
  const sticky = root.querySelector('[data-caw-sticky]');
  const desktop = matchMedia('(min-width: 1025px)');
  const params = new URLSearchParams(location.search);
  const debug = params.has('caw_ad_debug');
  const trace = params.has('caw_ad_log');
  const diagnostics = window.__PCH_CAW_ADS = { events: [] };
  const slots = [
    { element: rail, id: 'caw-ad-right-rail', base: 'pb-slot-right-rail', active: false },
    { element: sticky, id: 'caw-ad-bottom-sticky', base: 'pb-slot-bottom-sticky', active: false },
  ];
  const originalPadding = document.body.style.paddingBottom;
  const basePadding = parseFloat(getComputedStyle(document.body).paddingBottom) || 0;
  let loaded = false;
  let poll = null;
  let attempts = 0;
  const log = (message) => {
    diagnostics.events.push({ ms: Math.round(performance.now()), message });
    if (trace) console.info('[caw ads]', message);
  };
  function syncPadding() {
    document.body.style.paddingBottom = !sticky.hidden && sticky.classList.contains('is-filled')
      ? `${basePadding + sticky.offsetHeight}px` : originalPadding;
  }
  function reveal(slot, filled) {
    slot.element.classList.toggle('is-filled', filled);
    syncPadding();
  }
  function stop(slot) {
    if (slot.active && !debug) {
      window.tude?.destroyAds?.([slot.id]);
    }
    slot.active = false;
    slot.element.hidden = true;
    reveal(slot, false);
  }
  function loadWrapper() {
    if (loaded || debug) return;
    loaded = true;
    // Instantiate the shared loader only on giveaway views. Scripts cloned
    // from a template must be recreated to execute (identity precedes loader).
    const fragment = root.querySelector('template').content.cloneNode(true);
    for (const child of [...fragment.children]) {
      if (child.tagName === 'SCRIPT') {
        const script = document.createElement('script');
        for (const attr of child.attributes) script.setAttribute(attr.name, attr.value);
        script.textContent = child.textContent;
        document.head.appendChild(script);
      } else {
        document.head.appendChild(child);
      }
    }
  }
  function request(slot) {
    if (slot.active) return;
    if (debug) {
      const target = document.getElementById(slot.id);
      target.replaceChildren();
      const creative = document.createElement('div');
      creative.className = 'caw-ad-debug';
      creative.textContent = slot.base;
      target.appendChild(creative);
      slot.active = true;
      reveal(slot, true);
      return;
    }
    const api = window.tude;
    if (typeof api?.refreshAdsViaDivMappings !== 'function' || typeof api.setPageTargeting !== 'function') return;
    const tier = window.__PCH_GAM_TIER;
    const targeting = { module: 'clickandwin' };
    if (tier) targeting.tier = tier;
    api.setPageTargeting(targeting);
    api.refreshAdsViaDivMappings([{ divId: slot.id, baseDivId: slot.base }]);
    slot.active = true;
    log(`requested ${slot.base}`);
  }
  function sync() {
    const panel = flow.querySelector('.caw__giveaway:not([hidden])');
    const mount = panel?.querySelector('[data-caw-rail-mount]');
    if (!panel || !mount) {
      slots.forEach(stop);
      clearInterval(poll);
      poll = null;
      return;
    }
    if (desktop.matches) {
      // Only move the rail when it isn't already mounted. appendChild on an
      // in-place node still detaches and reinserts it, which reloads the
      // creative's iframe and blanks a rendered ad (seen on first serve,
      // when pageshow re-ran sync() after the ad had already rendered).
      if (rail.parentElement !== mount) mount.appendChild(rail);
      rail.hidden = false;
    } else {
      stop(slots[0]);
    }
    // Keep the sticky outside hidden panels and the inert root.
    if (sticky.parentElement !== document.body) document.body.appendChild(sticky);
    sticky.hidden = false;
    loadWrapper();
    for (const slot of slots) if (!slot.element.hidden) request(slot);
    const waiting = slots.some(slot => !slot.element.hidden && !slot.active);
    if (waiting && !poll && attempts < 150) {
      // Existing game sticky uses readiness polling because bootstrap can
      // replace the initial tude.cmd queue. This is not an ad refresh timer.
      poll = setInterval(() => {
        if (++attempts >= 150) {
          clearInterval(poll);
          poll = null;
          log('wrapper readiness timed out');
          return;
        }
        safeSync();
      }, 200);
    } else if (!waiting) {
      clearInterval(poll);
      poll = null;
    }
    syncPadding();
  }
  function safeSync() {
    try { sync(); } catch (error) { log(`error: ${error.message}`); }
  }
  if (!debug) {
    // Another script may create googletag before GPT initializes its queue.
    // Initialize both independently, preserving an existing GPT command queue.
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];
    window.googletag.cmd.push(() => {
      window.googletag.pubads().addEventListener('slotRenderEnded', event => {
        const id = event.slot.getSlotElementId();
        const el = document.getElementById(id);
        const slot = slots.find(item => item.id === id || (el && item.element.contains(el)));
        if (!slot || slot.element.hidden) return;
        reveal(slot, !event.isEmpty);
        log(`${slot.base}: ${event.isEmpty ? 'empty' : 'filled'}`);
      });
    });
  }
  new ResizeObserver(syncPadding).observe(sticky);
  // Observe only panel visibility; never our own hidden attributes or ad DOM.
  const observer = new MutationObserver(safeSync);
  flow.querySelectorAll('.caw__giveaway').forEach(panel =>
    observer.observe(panel, { attributes: true, attributeFilter: ['hidden'] }));
  desktop.addEventListener('change', safeSync);
  window.addEventListener('resize', syncPadding);
  // Only needed when a page is restored from the back/forward cache; a
  // normal load already synced via whenDefined below.
  window.addEventListener('pageshow', (event) => { if (event.persisted) safeSync(); });
  // The flow's connectedCallback selects ?step=done before this executes.
  customElements.whenDefined('click-and-win-flow').then(safeSync);
})();
